import styled from "styled-components";

export const MainWrapper = styled.div`
  border-radius: 1178px;
  background: linear-gradient(
    180deg,
    rgba(255, 199, 0, 0.57) 41.26%,
    rgba(236, 139, 49, 0.53) 136.34%
  );
  filter: blur(250px);
  height: 600px;
  width: 350px;
`;

export const FaqWrapper = styled.div`
  border-radius: 1178px;
  background: linear-gradient(
    180deg,
    rgba(255, 199, 0, 0.57) 41.26%,
    rgba(236, 139, 49, 0.53) 136.34%
  );
  filter: blur(230px);
  height: 300px;
  width: 400px;
  @media (max-width: 767px) {
    filter: blur(380px);
  }
`;

export const FooterWrapper = styled.div`
  border-radius: 1178px;
  background: linear-gradient(
    180deg,
    rgba(255, 199, 0, 0.57) 41.26%,
    rgba(236, 139, 49, 0.53) 136.34%
  );
  filter: blur(130px);
  height: 100px;
  width: 500px;

  @media (max-width: 767px) {
    filter: blur(150px);
  }
`;
